import {
  addLoading,
  changeActiveDeveloperAsync,
  changePassword,
  forceLogout,
  hideAlert,
  hideConfirm,
  login,
  logout,
  registerApiAsync,
  registerApplicationAsync,
  registerCategoryAsync,
  registerDeveloperAsync,
  removeLoading,
  showConfirm,
  showError,
  showSuccess,
  toggleMenu,
  updateApiAsync,
  updateApplicationAsync,
  resetDeveloperPasswordAsync,
  registerClusterDBAsync,
  changeMaxRecordAsync,
} from '@redux/actions';
import { createSlice } from '@reduxjs/toolkit';

const initialState: AppState = {
  openMenu: true,
  loadingCount: 0,
  alert: { show: false },
  dialogConfirm: { show: false },
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(toggleMenu, (state) => {
        state.openMenu = !state.openMenu;
      })
      .addCase(addLoading, (state) => {
        state.loadingCount++;
      })
      .addCase(removeLoading, (state) => {
        state.loadingCount--;
      })
      .addCase(showError, (state, { payload }) => {
        state.alert = {
          show: true,
          type: 'error',
          ...payload,
        };
      })
      .addCase(showSuccess, (state, { payload }) => {
        state.alert = {
          show: true,
          type: 'success',
          ...payload,
        };
      })
      .addCase(hideAlert, (state) => {
        state.alert.show = false;
      })
      .addCase(showConfirm, (state, { payload }) => {
        state.dialogConfirm = {
          show: true,
          ...payload,
        };
      })
      .addCase(hideConfirm, (state) => {
        state.dialogConfirm.show = false;
      })
      .addCase(forceLogout, (state) => {
        state.alert = {
          show: true,
          type: 'warning',
          message: 'MSW00003',
        };
      })
      .addCase(login.fulfilled, (state, { payload }) => {
        if (payload.user.forceChangePassword) {
          state.alert = {
            show: true,
            type: 'warning',
            message: 'MSW00004',
          };
        }
      })
      .addCase(logout.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00005',
        };
      })
      .addCase(changePassword.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00003',
        };
      })
      .addCase(registerDeveloperAsync.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00008',
        };
      })
      .addCase(changeActiveDeveloperAsync.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00003',
        };
      })
      .addCase(resetDeveloperPasswordAsync.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00009',
        };
      })
      .addCase(registerApplicationAsync.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00004',
        };
      })
      .addCase(updateApplicationAsync.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00003',
        };
      })
      .addCase(registerClusterDBAsync.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00004',
        };
      })
      .addCase(registerCategoryAsync.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00004',
        };
      })
      .addCase(registerApiAsync.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00004',
        };
      })
      .addCase(updateApiAsync.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00003',
        };
      })
      .addCase(changeMaxRecordAsync.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00003',
        };
      });
  },
});

export default appSlice.reducer;
